import { render, staticRenderFns } from "./StudentInfoComponent.vue?vue&type=template&id=258cfec5&"
import script from "./StudentInfoComponent.vue?vue&type=script&lang=ts&"
export * from "./StudentInfoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258cfec5')) {
      api.createRecord('258cfec5', component.options)
    } else {
      api.reload('258cfec5', component.options)
    }
    module.hot.accept("./StudentInfoComponent.vue?vue&type=template&id=258cfec5&", function () {
      api.rerender('258cfec5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/InProcessing/StudentInfoComponent.vue"
export default component.exports